import {configureStore} from "@reduxjs/toolkit";

import userAPI from "./api/userAPI";
import datasetSliceApi from "./api/datasetSliceApi";
import notifications from "./api/notifications";

const store = configureStore({
    reducer: {
        userAPI,
        datasetSliceApi,
        notifications
    }
})

export default store;
